import {
  ASSESSMENTS_TOKEN_MIN_REFRESH_DELAY_MS,
  ASSESSMENTS_TOKEN_REFRESH_BUFFER_MS,
} from '../constants';

// Time until the next exchange, or null when the response gives no usable expiry
export const getRefreshDelayMs = (expiresAt: string): number | null => {
  const expiresAtMs = Number(expiresAt) * 1000;

  return Number.isFinite(expiresAtMs) && expiresAtMs > 0
    ? Math.max(
        expiresAtMs - Date.now() - ASSESSMENTS_TOKEN_REFRESH_BUFFER_MS,
        ASSESSMENTS_TOKEN_MIN_REFRESH_DELAY_MS,
      )
    : null;
};
